export default __webpack_public_path__ + "static/media/Childseat.c648fc45.png";